import { useEffect, useState } from "react";

const KEY = "msl-splash-seen";
const SHOW_ON_LOAD = !sessionStorage.getItem(KEY);
sessionStorage.setItem(KEY, "1");

export const Splash = () => {
  const [phase, setPhase] = useState(SHOW_ON_LOAD ? "show" : "done");
  useEffect(() => {
    if (!SHOW_ON_LOAD) {
      return;
    }
    const t1 = setTimeout(() => setPhase("hide"), 2300);
    const t2 = setTimeout(() => setPhase("done"), 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);
  if (phase === "done") return null;
  return (
    <div data-testid="splash-screen" onClick={() => setPhase("done")}
      className={`fixed inset-0 z-[100] bg-noir flex flex-col items-center justify-center transition-opacity duration-700 ${phase === "hide" ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
      <div className="absolute w-[28rem] h-[28rem] rounded-full bg-gold/10 blur-3xl animate-[splash-glow_2.6s_ease-out_both]" />
      <img src="/brand/logo-oro.png" alt="Skin Lovers Professional"
        className="relative w-[72vw] max-w-[420px] h-auto animate-[splash-logo_1.6s_cubic-bezier(0.22,1,0.36,1)_both]" />
      <span className="relative mt-8 h-px w-0 bg-gradient-to-r from-transparent via-gold to-transparent animate-[splash-line_1.2s_ease-out_0.9s_both]" />
    </div>
  );
};
